import React from "react";
import { Task as T } from "@planzone/dto";
import classNames from "classnames";
import { Props } from "./types";
import styles from "./styles.scss";

function Task({ element, progress }: Props) {
  const { startDate, endDate } = element as T;
  const withStartDate = !!startDate && !endDate;
  const withEndDate = !startDate && !!endDate;

  return (
    <div
      className={classNames(styles.task, {
        [styles.unScheduled]: !startDate || !endDate,
        [styles.withStartDate]: withStartDate,
        [styles.withEndDate]: withEndDate,
        [styles.completed]: progress === 100,
      })}
    />
  );
}

export { Task };
